module.exports = __webpack_public_path__ + "img/scene4.03817511.png";